export default "__VITE_ASSET__BS1qQ$cH__"